/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UniversalProjectHitSchemaStatus } from './universalProjectHitSchemaStatus';

export interface UniversalProjectHitSchema {
  id: string;
  /** @maxLength 255 */
  title: string;
  status: UniversalProjectHitSchemaStatus;
  cover_image_url?: string | null;
}
